<template>
  <div class="container page">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({ path: '/WithdrawRecord' })">{{ $t("withdraw.with_record")
        }}</span>
      </template>
    </van-nav-bar>
    <div class="main">
      <div style="height: 60px;"></div>
      <div class="withdrawMoney">
        <span>{{ $t("withdraw.with_money") }} ({{ $t("reservation.unit") }})</span>
        <div class="money">
          <div class="moneyNumber">

            <van-field v-model="withdraw_money" type="number" />
          </div>
          <span class="all" @click="allMoeny()">{{ $t("index.all") }}</span>
        </div>

        <div class="type-select-wrap">
          <div class="type-label">{{ $t("txfs") }}</div>
          <div class="type-select" @click="showTypePopupFun">
            <span :style="{ 'color': selectedTypeName === '' ? '#999' : '#000' }">{{ selectedTypeName || $t("xztxfs")
            }}</span>
            <van-icon name="arrow-down" />
          </div>
        </div>
        <div class="type-select-wrap" v-if="selectedUsername != '' && selectedType === 0">
          <div class="type-label">{{ $t("setting.username") }}</div>
          <div class="type-select">
            <span :style="{ 'color': selectedUsername === '' ? '#999' : '#000' }">{{ selectedUsername }}</span>
          </div>
        </div>
        <div class="type-select-wrap" v-if="selectedBankName != '' && selectedType === 0">
          <div class="type-label">{{ $t("setting.band_name") }}</div>
          <div class="type-select">
            <span :style="{ 'color': selectedBankName === '' ? '#999' : '#000' }">{{ selectedBankName }}</span>
          </div>
        </div>
        <div class="type-select-wrap" v-if="selectedAddress != ''">
          <div class="type-label">{{ selectedType === 0 ? $t("setting.band_account") : $t("zhmcc") }}</div>
          <div class="type-select">
            <span :style="{ 'color': selectedAddress === '' ? '#999' : '#000' }">{{ selectedAddress }}</span>
          </div>
        </div>

        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">
                <p>
                  1.{{ $t("withdraw.single_limit") }}{{ $t("withdraw.low") }}{{ this.withdrawRole.min }}{{
                    $t("withdraw.heigh") }}{{ this.withdrawRole.max }}{{ $t("reservation.unit") }}
                </p>
                <p>2.{{ $t("withdraw.with_num") }}{{ this.withdrawRole.num }}{{ $t("withdraw.number") }}</p>
                <p>3.{{ $t("withdraw.with_tip") }}</p>
              </div>
              <template #reference @click="withdrawInfo()">
                <van-icon name="info-o" />
                {{ $t("withdraw.limit_desc") }}
              </template>
            </van-popover>
          </div>


          <div class="balance">
            <span>{{ $t("my.balance") }}：</span>
            <span class="number">{{ this.userInfo.money }}{{ $t("reservation.ge") }}</span>
          </div>
        </div>
      </div>
      <van-button class="withdraw_btn" type="default" @click="doWithdraw()">
        {{ $t("withdraw.immediately_withdraw") }}</van-button>

    </div>
    <van-popup v-model="showTypePopup" position="bottom">
      <div class="popup-content">
        <div class="popup-title">{{ $t("txfs") }}</div>
        <div class="popup-box">
          <div class="crads" :class="{ 'actives': selectedId+selectedType === item.id+item.type }" v-for="(item, index) in typeList"
            :key="index" @click="selectFun(item)">
            <img src="/img/mine/nav8.png" alt=""
              style="position: absolute;right: 10px;top: 50%;transform: translateY(-50%);">
            <div class="text1">
              {{ $t('types') }} : {{ item.typeName }}
            </div>
            <div class="text1">
              {{ item.type === 0 ? $t('zhkh') : $t('zhmcc') }} :{{ item.name }}
            </div>
          </div>
        </div>
        <van-button class="withdraw_btn" style="width:90%" type="default" @click="confirmType">
          {{ $t("comfrom") }}</van-button>
      </div>
    </van-popup>

    <div class="loading-box" v-if="loadings">
      <van-loading size="34px" />
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
  component: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      showPopover: false,
      withdraw_money: "",
      userInfo: {},
      withdrawRole: {},
      typeList: [],
      showTypePopup: false,
      selectedTypeName: '',
      selectedAddress: '',
      selectedUsername: '',
      selectedBankName: '',
      selectedId: '',
      selectedType: '',
      loadings: true,
      coinList: [
        { key: '0', label: 'USDT-ERC20', address: '' },
        { key: '1', label: 'USDT-TRC20', address: '' },
        { key: '2', label: 'BTC', address: '' },
        { key: '3', label: 'ETH', address: '' },
        { key: '4', label: 'USDC-ERC20', address: '' },
      ],
    };
  },
  methods: {
    selectFun(items) {
      console.log('items', items)
      this.selectedType = items.type
      this.selectedId = items.id
      this.selectedTypeName = items.typeName
      this.selectedAddress = items.name
      if (items.type === 0) {
        this.selectedUsername = items.username
        this.selectedBankName = items.bankName
      }
    },
    confirmType() {
      // console.log(item)
      this.showTypePopup = false;
    },
    showTypePopupFun() {
      let that = this
      if (this.typeList.length === 0) {
        Dialog.alert({
          message: that.$t('ts1'),
        }).then(() => {
          // on close
          that.$router.push({ path: '/Infomation' })
        });
        return
      }
      this.showTypePopup = true;
    },
    back() {
      return window.history.back();
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole() {
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res => {
        console.log('res->', res)
        if (res.code === 200) {
          this.withdrawRole = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        this.loadings = false
      })
    },
    allMoeny() {
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw() {
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t("setting.correct_money"));
        return false;
      } else {
        this.loadings = true
        this.$http({
          method: 'post',
          data: { money: this.withdraw_money, type: this.selectedType, bid: this.selectedId },
          url: 'user_set_withdraw'
        }).then(res => {
          // console.log('res2->', res)
          if (res.code === 200) {
            location.reload()
            this.$toast(res.msg);
            this.selectedType = ''
            this.selectedId = ''
            this.selectedTypeName = ''
            this.selectedUsername = ''
            this.selectedBankName = ''
            this.selectedAddress = ''
            this.getUserInfo();
            this.getUserWithdrawRole();
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
          this.loadings = false
        })
      }
    },
    withdrawInfo() {
      this.showPopover = true;
    },
    selectCoinFun(val) {
      // console.log(val,'val')
      let item = this.coinList.find(x => x.key === val + '')
      // console.log('item',item)
      return item.label
    },
  },
  async created() {
    if (!localStorage.getItem('token')) {
      this.loadings = false
      this.$router.push({ path: '/Login' })
    } else {
      await this.getUserInfo();
      await this.getUserWithdrawRole();
      await this.$http({
        method: 'get',
        url: 'getUserAddressInfo'
      }).then(res => {
        // console.log('res->', res)
        res.data.info.forEach(e => {
          let obj = {
            name: e.address,
            id: e.id,
            type: 1,
            typeName: this.selectCoinFun(e.type)
          }
          this.typeList.push(obj)
        })
        this.loading = false
      })
      await this.$http({
        method: 'get',
        url: 'user_get_bank',
        type: 0
      }).then(res => {
        if (res.code === 200) {
          if (res.data.info && res.data.info.bankid != '') {
            let obj = {
              name: res.data.info.bankid,
              id: res.data.info.id,
              type: 0,
              typeName: this.$t('YHK'),
              username: res.data.info.username,
              bankName: res.data.info.bankinfo
            }
            this.typeList.push(obj)
            this.loadings = false;
          } else {
            this.loadings = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
          this.loadings = false
        }
      })
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}

.container .main {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}

.container .main .withdrawMoney {
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}

.container .main .withdrawMoney span {
  padding: 10px 0;
}

.container .main .withdrawMoney .money {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}

.container .main .withdrawMoney .money .moneyNumber {
  font-size: 50px;
  display: flex;
  flex-direction: row;
}

.container .main .withdrawMoney span {
  padding: 10px 0;
}

.container .main .withdrawMoney .money .all {
  color: #d10404;
}

.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0 !important;
}

.container .main .withdrawMoney .information {
  padding-bottom: 30px;
}

.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}

.container .main .withdrawMoney span {
  padding: 10px 0;
}

.container .main .withdrawMoney .information .balance .number {
  color: #d10404;
}

.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
}

.type-select-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f2f2f5;
}

.type-label {
  font-size: 32px;
}

.type-select {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 32px;
  color: #333;
  cursor: pointer;
}

.popup-content {
  padding: 20px 30px 60px;

  .popup-box {
    width: 100%;
    padding: 20px;
    height: fit-content;
    max-height: 500px;
    overflow: hidden;
    overflow-y: scroll;

    .types {
      font-size: 28px;
      color: #000;
      padding: 10px;
      width: 150px;
    }

    .text1 {
      font-size: 28px;
      color: #000;
    }
  }

  .crads {
    width: 100%;
    height: fit-content;
    min-height: 130px;
    background: #fff;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
    position: relative;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    cursor: pointer;

    .types {
      display: block;
      width: fit-content;
      margin-bottom: 10px;
    }

    img {
      width: 80px;
      height: 80px;
      display: block;
    }
  }
}

.popup-title {
  text-align: center;
  font-size: 34px;
  padding: 20px 0;
}

.van-radio {
  font-size: 32px;
  margin: 16px 0;
}

.van-dialog__header {
  font-size: 30px;
}

.loading-box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20%;
}

.actives {
  background: linear-gradient(30deg, #7d76ef, #d63f8c) !important;

  .text1 {
    color: #fff !important;
  }
}
</style>
